import { Injectable } from '@angular/core';
import { PlanoVistoria } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/plano-vistoria.entity';
import { PlanoVistoriaItemDefeitoDto } from 'app/model/dtos/mob/plano-vistoria-item-defeito.dto';
import { PlanoVistoriaItemDto } from 'app/model/dtos/mob/plano-vistoria-item.dto';
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from 'src/environments/environmentv3';

@Injectable()
export class PlanoVistoriaController {

	constructor() { }
	
	async find(filtros?: IFilter):Promise<Array<PlanoVistoria>>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/planosvistoria',
					environment: environmentv3,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<PlanoVistoria>()
			)
		);
		return await quark.call();
	}

	async get(cdPlanoVistoria:number):Promise<PlanoVistoria>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/planosvistoria/:cdPlanoVistoria',
					environment: environmentv3,
					pathParams: new JSONData({cdPlanoVistoria: cdPlanoVistoria})
				}),
			}),
			new HttpResponse(
				new PlanoVistoria()
			)
        );
        return await quark.call();
	}

	async delete(cdPlanoVistoria:number):Promise<PlanoVistoria>{
        let quark = new Quark(
			new HttpDelete({
				url: new Url({
					id: 'mob/planosvistoria/:cdPlanoVistoria',
					environment: environmentv3,
					pathParams: new JSONData({cdPlanoVistoria: cdPlanoVistoria})
				}),
			}),
			new HttpResponse(
				new PlanoVistoria()
			)
        );
        return await quark.call();
	}

	async create(planoVistoria: PlanoVistoria):Promise<PlanoVistoria>{
        let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/planosvistoria',
					environment: environmentv3
				}),
				data: new JSONData(planoVistoria)
			}),
			new HttpResponse(
				new PlanoVistoria()
			)
        );
        return await quark.call();
	}

	async update(planoVistoria: PlanoVistoria):Promise<PlanoVistoria>{
        let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/planosvistoria/:cdPlanoVistoria',
					environment: environmentv3,
					pathParams: new JSONData({cdPlanoVistoria:planoVistoria.cdPlanoVistoria})
				}),
				data: new JSONData(planoVistoria)
			}),
			
			new HttpResponse(
				new PlanoVistoria()
			)
        );
		
        return await quark.call();
	}

	async getItens(cdPlanoVistoria:number):Promise<Array<PlanoVistoriaItemDto>>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/planosvistoria/:cdPlanoVistoria/itens',
					environment: environmentv3,
					pathParams: new JSONData({cdPlanoVistoria: cdPlanoVistoria})
				}),
			}),
			new HttpResponse(
				new Array<PlanoVistoriaItemDto>()
			)
        );
        return await quark.call();
	}

	async getItemDefeitos(cdPlanoVistoria:number, cdVistoriaItem:number):Promise<Array<PlanoVistoriaItemDefeitoDto>>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/planosvistoria/:cdPlanoVistoria/itens/:cdVistoriaItem/defeitos',
					environment: environmentv3,
					pathParams: new JSONData({cdPlanoVistoria: cdPlanoVistoria, cdVistoriaItem: cdVistoriaItem})
				}),
			}),
			new HttpResponse(
				new Array<PlanoVistoriaItemDefeitoDto>()
			)
        );
        return await quark.call();
	}

}